<template>
	<li>
		<a :href="url" :title="title" v-bind="$attrs">{{ name }}</a>
	</li>
</template>

<script>
export default {
	props: {
		/**
		 * Text in link
		 */
		name: {
			type: String,
			required: true
		},
		/**
		 * Title attribute
		 */
		title: {
			type: String,
			default: null,
		},
		/**
		 * Href value
		 */
		url: {
			type: String,
			required: true
		},
	}
}
</script>